import * as React from 'react';

/**
 * A link to a PR, issue, story or task at its source (GitHub or Teamwork). Every one opens in a
 * new tab (SHL-001), so the reader keeps their place in Pulse.
 */
export function SourceLink({
  href,
  className,
  style,
  children,
  'aria-label': ariaLabel,
}: {
  readonly href: string;
  readonly className?: string;
  readonly style?: React.CSSProperties;
  readonly children: React.ReactNode;
  readonly 'aria-label'?: string;
}): React.ReactElement {
  return (
    <a href={href} className={className} style={style} target="_blank" rel="noopener noreferrer" aria-label={ariaLabel}>
      {children}
    </a>
  );
}

const GITHUB = 'https://github.com/ten24group/';
const TEAMWORK_TASK = 'https://ten243.teamwork.com/app/tasks/';

/** Where each kind of source item lives. */
export const sourceUrl = {
  pullRequest: (repositoryName: string, number: number | string) => `${GITHUB}${repositoryName}/pull/${number}`,
  issue: (repositoryName: string, number: number | string) => `${GITHUB}${repositoryName}/issues/${number}`,
  task: (taskId: number | string) => `${TEAMWORK_TASK}${taskId}`,
  /** A story file on its repository's dev branch. */
  story: (repositoryName: string, branch: string, path: string) => `${GITHUB}${repositoryName}/blob/${branch}/${path}`,
};
